import 'babel-polyfill'
import 'material-design-icons-iconfont/dist/material-design-icons.css' // Ensure you are using css-loader

import Vue from 'vue'
import Vuetify from 'vuetify'

import * as VueGoogleMaps from "vue2-google-maps"

Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.MIX_GOOGLE_MAP_API_KEY
  }
})

require('./bootstrap')

/*
 * Set HTTP Request Header
 */
Vue.prototype.$http = axios.create({
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  },
  timeout: 30000,
  withCredentials: false
})


Vue.component('ghNavigatorMain', require('@/components/navigator/NavigatorMain').default)
Vue.component('ghFooterMain', require('@/components/footer/FooterMain').default)
Vue.component('ghFormBooking', require('@/components/form/Bookings').default)
Vue.component('ghFormModels', require('@/components/form/Models').default)
Vue.component('ghButtonCall', require('@/components/button/ButtonCall').default)
Vue.component('ghButtonEmail', require('@/components/button/ButtonEmail').default)
Vue.component('ghExpansionItems', require('@/components/ExpansionItems').default)
Vue.component('ghHomeVideo', require('@/components/HomeVideo').default)
Vue.component('ghMemberRow', require('@/components/MemberRow').default)
Vue.component('ghMap', require('@/components/map/Map').default)

new Vue({
  vuetify: new Vuetify({
    icons: {
      iconfont: 'md',
    },
    theme: { disable: true }
  }),
  
  data () {
    return {
      serviceTab: 0,
      fab: false
    }
  },
  
  mounted () {
    this.scrollToSection()
  },
  
  methods: {
    onScroll (e) {
      if (typeof window === 'undefined') return
      const top = window.pageYOffset || e.target.scrollTop || 0
      this.fab = top > 100
    },
    
    toTop () {
      this.$vuetify.goTo(0)
    },
    
    scrollToSection () {
      if (!window.location.hash) return
      
      const element = document.querySelector(window.location.hash)
      if (!element) return
  
      this.$vuetify.goTo(element.offsetTop)
    }
  }
})
  .$mount('#gh-app')
